import CloseIcon from '../Icons/CloseIcon';

type Props = {
  className?: string;
  onClick: () => void;
};

const CloseButton = ({ className = '', onClick }: Props) => {
  return (
    <button
      aria-label="Schließe Modal"
      className={`rounded-full border-[0.5px] border-orange-500/70 bg-orange-400 p-1 text-white shadow-lg active:!bg-orange-600 active:shadow-inner [@media(hover:hover)]:hover:bg-orange-500 ${className}`}
      onClick={onClick}
    >
      <CloseIcon />
    </button>
  );
};

export default CloseButton;
